module.exports = __webpack_public_path__ + "img/4.e83bb675.png";